import { createFileRoute } from '@tanstack/react-router'
import { CoursesRachunkowoscList } from '@/pages/Courses/CoursesRachunkowoscList'

export const Route = createFileRoute('/(app)/_app/courses_/kurs-rachunkowosc')({
  component: CoursesRachunkowoscList,
})
